<template>
  <div class="signup-page">
    <div class="signup-card">
      <h2>Sign up</h2>
      <form @submit.prevent="signup">
        <div class="mb-3">
          <label for="userId" class="form-label">Name</label>
          <input type="text" v-model="name" class="form-control" id="userId" required />
        </div>
        <div class="mb-3">
          <label for="userId" class="form-label">Phone Number</label>
          <input type="text" v-model="phoneNumber" class="form-control" id="userId" required />
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <input type="password" v-model="password" class="form-control" id="password" required />
        </div>
        <button type="submit" class="btn btn-dark w-100">Sign up</button>
        <p v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</p>
      </form>
      <p class="mt-3">Already have an account? <router-link to="/login">Go To Login</router-link></p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { BASE_URL } from '@/globals'
import { usePageMeta } from '@/composables/usePageMeta';

export default {
  name: 'SignupComponent',
  data() {
    return {
      name: '',
      phoneNumber: '',
      password: '',
      errorMessage: '',
    };
  },
  mounted() {
    usePageMeta({
      title: "Signup | Sehrish mart",
      description: "Place for quality skincare items",
      image: "",
    });
  },
  methods: {
    async signup() {
      try {
        const body = { 
          name: this.name,
          phoneNumber: this.phoneNumber,
          password: this.password 
        }
        await axios.post(`${BASE_URL}/api/auth/register`, body);
        this.$router.push('/login');
      } catch (error) {
        this.errorMessage = error.response.data.message;
      }
    },
  },
};
</script>

<style scoped>
.signup-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: linear-gradient(135deg, #fdeef1 0%, #f4f5fb 100%);
}

.signup-card {
  width: 100%;
  max-width: 560px;
  background: #f7f8fc;
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.08);
}

.signup-card h2 {
  margin-bottom: 1.5rem;
}
</style>
